import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { routeNames } from '../../../shared/route-names';
import { UserService } from '../../user/services/user.service';
import { ReturnUrlService } from '../../auth/services/return-url.service';

export const GuestGuard = () => {
  const router = inject(Router);
  const userService = inject(UserService);
  const returnUrlService = inject(ReturnUrlService);

  if (userService.isLoggedIn()) {
    // User is already logged in, redirect to return URL or home
    const returnUrl = returnUrlService.getReturnUrlOrDefault(routeNames.home);
    return router.navigateByUrl(returnUrl);
  }

  return true;
};
